import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber7Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNumber7Square"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM9.01758 7.79492V9.03125H13.377V9.125L9.70312 16.25H11.2852L14.9004 9.05469V7.79492H9.01758Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber7Square;
